export default "__VITE_ASSET__f33ef034__"